/* eslint-disable */
import React, { useReducer, useEffect, useState } from 'react'
import { Button, Card, CardBody, Col, Input, Label, Row, InputGroup, InputGroupText, Form, FormFeedback } from 'reactstrap'
import AsyncSelect from 'react-select/async'
import axios from 'axios'
import Select from 'react-select'
import { selectThemeColors } from '@utils'
import toast from 'react-hot-toast'
import { Controller, useForm } from 'react-hook-form'
import * as yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'
import { configGetDizionariCombo, configSetProdottoGenerale } from '../../../../@core/auth/apiService/configs'
import { useNavigate } from "react-router-dom"



// STATO SERVIZIO OPZIONI
const statoServizioOptions = [
    { value: 'Operativo', label: 'Operativo' },
    { value: 'Sviluppo', label: 'Sviluppo' },
    { value: 'Ritirato', label: 'Ritirato' }]
// REDUCER E ACTIONS
const reducer = (state, { type, payload }) => {
    switch (type) {
        case 'MODIFICA_CODICE':
            return { ...state, codice: payload || '' }
        case 'MODIFICA_NOME':
            return { ...state, nome: payload || '' }
        case 'MODIFICA_TIPOPRODOTTO':
            return { ...state, tipoProdotto: { id: payload || '' } }
        case 'MODIFICA_UNITAMISURA':
            return { ...state, unitaMisura: { id: payload || '' } }
        case 'MODIFICA_UNITAUTILIZZATA':
            return { ...state, unitaUtilizzo: { id: payload || '' } }
        case 'MODIFICA_SETATTRIBUTO':
            return { ...state, setAttributi: { id: payload || '' } }
        case 'MODIFICA_CATEGORIA':
            return { ...state, categorie: [{ id: payload || '' }] }
        case 'MODIFICA_ALIQUOTAIVA':
            return { ...state, aliquotaIva: { id: payload || '' } }
        case 'MODIFICA_COSTO':
            return { ...state, costo: payload || '' }
        case 'MODIFICA_PREZZOVENDITA':
            return { ...state, prezzoVendita: payload || '' }
        case 'MODIFICA_STATOSERVIZIO':
            return { ...state, statoServizio: payload || '' }
        case 'MODIFICA_DESCRIZIONEBREVE':
            return { ...state, descrizioneBreve: payload || '' }
        case 'MODIFICA_NOTE':
            return { ...state, note: payload || '' }
        case 'MODIFICA_ATTIVO':
            if (payload.target.checked === false) { return ({ ...state, attivo: 0 }) }
            else return { ...state, attivo: 1 }
        case 'MODIFICA_DISPONIBILE':
            if (payload.target.checked === false) { return ({ ...state, disponibile: 0 }) }
            else return { ...state, disponibile: 1 }
        case 'MODIFICA_VISIBILE':
            if (payload.target.checked === false) { return ({ ...state, visibile: 0 }) }
            else return { ...state, visibile: 1 }
        case 'MODIFICA_EVIDENZA':
            if (payload.target.checked === false) { return ({ ...state, inEvidenza: 0 }) }
            else return { ...state, inEvidenza: 1 }
        default:
            return { ...state }
    }
}


const DetailsGeneral = (props) => {
    const navigate = useNavigate()
    //DECOSTRUZIONE OGGETTO PROPS
    const { value, pullData } = props
    const { id, codice, nome, categorie, unitaMisura, unitaUtilizzo, statoServizio, prezzoVendita, tipoProdotto, costo, attivo, disponibile, visibile, inEvidenza, aliquotaIva, setAttributi, descrizioneBreve, note } = value
    const [tipo, setTipo] = useState(tipoProdotto.descrizione)
    //STATE INIZIALE OTTENUTO DALLA CHIAMATA SU DETAILS.JS PASSATA TRAMITE PROPS SOLO DOPO IL CONTROLLO 
    const initialState = {
        id: id,
        codice: codice,
        nome: nome,
        tipoProdotto: {
            id: tipoProdotto.id
        },
        unitaMisura: {
            id: unitaMisura.id
        },
        unitaUtilizzo: {
            id: unitaUtilizzo.id
        },
        setAttributi: {
            id: setAttributi.id
        },
        categorie: [{ id: categorie.id_categoria || 1 }],
        aliquotaIva: {
            id: aliquotaIva.id
        },
        prezzoVendita: prezzoVendita,
        costo: costo,
        descrizioneBreve: descrizioneBreve,
        note: note,
        statoServizio: statoServizio,
        attivo: attivo,
        visibile: visibile,
        disponibile: disponibile,
        inEvidenza: inEvidenza
    }

    const [state, dispatch] = useReducer(reducer, initialState)

    useEffect(() => {
        pullData(tipo)
    }, [tipo])

    const invioModifica = async () => {

        const myResponse = await axios(configSetProdottoGenerale(JSON.stringify([state])))
        if (myResponse.data.esito === 'OK') {
            if (state.id === 0) {
                toast.success('Prodotto aggiunto con successo', {
                    position: "top-right",
                    duration: 3000,
                    style: {
                        background: 'green',
                        color: 'white'
                    }
                })
            } else {
                toast.success('Prodotto/i modificato/i con successo', {
                    position: "top-right",
                    duration: 3000,
                    style: {
                        background: 'green',
                        color: 'white'
                    }
                })
            }

            navigate(`/products/${myResponse.data.prodotto[0].id}`)
        } else {
            {
                toast.error('Si è verificato un errore durante la richiesta al server, verifica i dati inseriti o ricarica la pagina', {
                    position: "top-right",
                    duration: 3000,
                    style: {
                        background: 'red',
                        color: 'white'
                    }
                })
            }

        }
    }
    const onError = (errors, e) => {
        toast.error('Modifica non eseguita, controlla i campi richiesti', {
            position: "top-right",
            duration: 3000,
            style: {
                background: 'red',
                color: 'white'
            }
        })
    };

    const onSubmit = () => {
        invioModifica()
    }

    const defaultSchema = yup.object().shape({
        codice: yup.string().required(),
        nome: yup.string().required(),
        categorie: yup.array().required(),
        costo: yup.number().required(),
        prezzoVendita: yup.number().required(),

    })
    //useForm per la validazione
    const {
        control,
        handleSubmit,
        formState: { errors }
    } = useForm({ mode: 'onChange', resolver: yupResolver(defaultSchema), defaultValues: state })
    return (
        <Card className='w-100'>
            <CardBody>
                <Form onSubmit={handleSubmit(onSubmit, onError)}>
                    <Row>
                        <div className='d-flex flex-rows'>
                            <Col className='mb-2' xl='2' md='3' sm='6'>
                                <Label for='attivoSwitch' className='form-check-label'>
                                    Attivo
                                </Label>
                                <div className='form-switch form-check-primary'>

                                    <Input type='switch' id='attivoSwitch' name='attivo' value={state.attivo || ''} onClick={(e) => { dispatch({ type: 'MODIFICA_ATTIVO', payload: e }) }} defaultChecked={state.attivo === 1 ? true : false} />
                                </div>
                            </Col>
                            <Col className='mb-2' xl='2' md='3' sm='6'>
                                <Label for='disponibileSwitch' className='form-check-label'>
                                    Disponibile
                                </Label>
                                <div className='form-switch form-check-primary'>

                                    <Input type='switch' id='disponibileSwitch' name='disponibile' value={state.disponibile || ''} onClick={(e) => { dispatch({ type: 'MODIFICA_DISPONIBILE', payload: e }) }} defaultChecked={state.disponibile === 1 ? true : false} />
                                </div>
                            </Col>
                            <Col className='mb-2' xl='2' md='3' sm='6'>
                                <Label for='visibileSwitch' className='form-check-label '>
                                    Visibile
                                </Label>
                                <div className='form-switch form-check-primary'>

                                    <Input type='switch' id='visibileSwitch' name='visibile' value={state.visibile || ''} onClick={(e) => { dispatch({ type: 'MODIFICA_VISIBILE', payload: e }) }} defaultChecked={state.visibile === 1 ? true : false} />
                                </div>
                            </Col>
                            <Col className='mb-2' xl='2' md='3' sm='6'>
                                <Label for='evidenzaSwitch' className='form-check-label '>
                                    In Evidenza
                                </Label>
                                <div className='form-switch form-check-primary'>

                                    <Input type='switch' id='evidenzaSwitch' name='evidenza' value={state.inEvidenza || ''} onClick={(e) => { dispatch({ type: 'MODIFICA_EVIDENZA', payload: e }) }} defaultChecked={state.inEvidenza === 1 ? true : false} />
                                </div>
                            </Col>
                        </div>
                    </Row>
                    <Row>
                        <Col className='mb-1' xl='4' md='6' sm='12'>
                            <Label className='form-label' for='codice'>
                                Codice
                            </Label>
                            <Controller
                                id='codice'
                                name='codice'
                                defaultValue={state.codice || ''}
                                control={control}
                                render={({ field: { value, onChange, ...field } }) => <Input {...field} onChange={({ target: { value } }) => {
                                    onChange(value);
                                    dispatch({ type: 'MODIFICA_CODICE', payload: value })
                                }}
                                    value={state.codice || ''}
                                    invalid={errors.codice && true} />}
                            />
                            {errors.codice && <FormFeedback>{'Il campo Codice non può essere vuoto'}</FormFeedback>}
                        </Col>
                        <Col className='mb-1' xl='4' md='6' sm='12'>
                            <Label className='form-label' for='nome'>
                                Nome
                            </Label>
                            <Controller
                                id='nome'
                                name='nome'
                                defaultValue=''
                                control={control}
                                render={({ field: { value, onChange, ...field } }) => <Input {...field} onChange={({ target: { value } }) => {
                                    onChange(value);
                                    dispatch({ type: 'MODIFICA_NOME', payload: value })
                                }}
                                    value={state.nome || ''}
                                    invalid={errors.nome && true} />}
                            />
                            {errors.nome && <FormFeedback>{'Il campo Nome non può essere vuoto'}</FormFeedback>}
                        </Col>
                        <Col className='mb-1' xl='4' md='6' sm='12'>
                            <Label className='form-label' for='tipo'>
                                Tipo
                            </Label>
                            <AsyncSelect
                                defaultInputValue={tipoProdotto.descrizione}
                                cacheOptions
                                defaultOptions
                                loadOptions={async () => {
                                    const myResponse = await axios(configGetDizionariCombo({}))
                                    const prodotti = myResponse.data.tipoProdotto.map(item => ({

                                        ...item,
                                        label: item.descrizione,
                                        value: item.id,
                                    }));
                                    return prodotti;
                                }}
                                onChange={(e) => {
                                    dispatch({ type: 'MODIFICA_TIPOPRODOTTO', payload: e.id })
                                    setTipo(e.descrizione)
                                }}
                                name='tipo'
                                className='react-select'
                                classNamePrefix='select'
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col className='mb-1' xl='4' md='6' sm='12'>
                            <Label className='form-label' for='unita'>
                                Unità
                            </Label>
                            <AsyncSelect
                                defaultInputValue={unitaMisura.descrizione}
                                cacheOptions
                                defaultOptions
                                loadOptions={async () => {
                                    const myResponse = await axios(configGetDizionariCombo({}))
                                    const prodotti = myResponse.data.unitaMisura.map(item => ({
                                        ...item,
                                        label: item.descrizione,
                                        value: item.id,
                                    }));
                                    return prodotti;
                                }}
                                onChange={(e) => { dispatch({ type: 'MODIFICA_UNITAMISURA', payload: e.id }) }}
                                name='unita'
                                className='react-select'
                                classNamePrefix='select'
                            />
                        </Col>
                        <Col className='mb-1' xl='4' md='6' sm='12'>
                            <Label className='form-label' for='unitaUtilizzata'>
                                Unità Utilizzata
                            </Label>
                            <AsyncSelect

                                defaultInputValue={unitaUtilizzo.descrizione}
                                cacheOptions
                                loadOptions={async () => {
                                    const myResponse = await axios(configGetDizionariCombo({}))
                                    const prodotti = myResponse.data.unitaUtilizzo.map(item => ({
                                        ...item,
                                        label: item.descrizione,
                                        value: item.id,
                                    }));
                                    return prodotti;
                                }}
                                defaultOptions
                                onChange={(e) => { dispatch({ type: 'MODIFICA_UNITAUTILIZZATA', payload: e.id }) }}
                                name='unitaUtilizzo'
                                className='react-select'
                                classNamePrefix='select'
                            />
                        </Col>
                        <Col className='mb-1' xl='4' md='6' sm='12'>
                            <Label className='form-label' for='setAttributi'>
                                Set Attributi
                            </Label>
                            <AsyncSelect

                                defaultInputValue={setAttributi.descrizione}
                                cacheOptions
                                loadOptions={async () => {
                                    const myResponse = await axios(configGetDizionariCombo({}))
                                    const prodotti = myResponse.data.setAttributo.map(item => ({
                                        ...item,
                                        label: 'Default',
                                        value: item.id,
                                    }));
                                    return prodotti;
                                }}
                                defaultOptions
                                onChange={(e) => { dispatch({ type: 'MODIFICA_SETATTRIBUTO', payload: e.id }) }}
                                name='setAttributo'
                                className='react-select'
                                classNamePrefix='select'
                            />
                        </Col>
                        <Col className='mb-1' xl='4' md='6' sm='12'>
                            <Label className='form-label' for='categorie'>
                                Categorie
                            </Label>
                            <AsyncSelect

                                defaultInputValue={categorie.length > 0 ? categorie[0].id_categoria : 'null'}
                                cacheOptions
                                theme={selectThemeColors}
                                defaultOptions
                                isMulti
                                loadOptions={async () => {
                                    const myResponse = await axios(configGetDizionariCombo({}))
                                    const prodotti = myResponse.data.categoria.map(item => ({
                                        ...item,
                                        label: item.descrizione,
                                        value: item.id,
                                    }));
                                    return prodotti;
                                }}
                                onChange={(e) => { dispatch({ type: 'MODIFICA_CATEGORIA', payload: e.length > 0 ? e[0].id : 'null' }) }}
                                name='colors'
                                className='react-select'
                                classNamePrefix='select'
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col className='mb-1' xl='4' md='6' sm='12'>
                            <Label className='form-label' for='ivaVendita'>
                                Iva Vendita
                            </Label>
                            <AsyncSelect

                                defaultInputValue={aliquotaIva.descrizione}
                                cacheOptions
                                defaultOptions
                                loadOptions={async () => {
                                    const myResponse = await axios(configGetDizionariCombo({}))
                                    const prodotti = myResponse.data.aliquotaIva.map(item => ({
                                        ...item,
                                        label: item.descrizione,
                                        value: item.id,
                                    }));
                                    return prodotti;
                                }}
                                onChange={(e) => { dispatch({ type: 'MODIFICA_ALIQUOTAIVA', payload: e.id }) }}
                                name='ivaVendita'
                                className='react-select'
                                classNamePrefix='select'
                            />
                        </Col>
                        <Col className='mb-1' xl='4' md='6' sm='12'>
                            <Label className='form-label' for='costoAcquisto'>
                                Costo Acquisto
                            </Label>
                            <InputGroup className=''>
                                <InputGroupText>€</InputGroupText>
                                <Controller
                                    type='number'
                                    id='costo'
                                    name='costo'
                                    defaultValue=''
                                    control={control}
                                    render={({ field: { value, onChange, ...field } }) => <Input {...field} onChange={({ target: { value } }) => {
                                        onChange(value);
                                        dispatch({ type: 'MODIFICA_COSTO', payload: value })
                                    }}
                                        value={state.costo || ''}
                                        invalid={errors.costo && true} />}
                                />
                                {errors.costo && <FormFeedback>{'Il campo Costo non può essere vuoto'}</FormFeedback>}
                            </InputGroup>
                        </Col>
                        <Col className='mb-1' xl='4' md='6' sm='12'>
                            <Label className='form-label' for='prezzoVendita'>
                                Prezzo Vendita
                            </Label>
                            <InputGroup className=''>
                                <InputGroupText>€</InputGroupText>
                                <Controller
                                    type='number'
                                    id='prezzoVendita'
                                    name='prezzoVendita'
                                    defaultValue=''
                                    control={control}
                                    render={({ field: { value, onChange, ...field } }) => <Input {...field} onChange={({ target: { value } }) => {
                                        onChange(value);
                                        dispatch({ type: 'MODIFICA_PREZZOVENDITA', payload: value })
                                    }}
                                        value={state.prezzoVendita || ''}
                                        invalid={errors.prezzoVendita && true} />}
                                />
                                {errors.prezzoVendita && <FormFeedback>{'Il campo Prezzo non può essere vuoto'}</FormFeedback>}
                            </InputGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col className='mb-1' xl='4' md='6' sm='12'>
                            <Label className='form-label' for='statoServizio'>
                                Stato Servizio
                            </Label>
                            <Select
                                className='react-select'
                                classNamePrefix='select'
                                value={statoServizioOptions.filter(statoServizioOptions => statoServizioOptions.value === state.statoServizio)}
                                options={statoServizioOptions}
                                isClearable={false}
                                onChange={(e) => { dispatch({ type: 'MODIFICA_STATOSERVIZIO', payload: e.value }) }}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col className='mb-1' sm='12'>
                            <Label className='form-label' for='descrizioneBreve'>
                                Descrizione Breve
                            </Label>
                            <Col sm={12}>
                                <Input
                                    value={state.descrizioneBreve || ''}
                                    id="descrizioneBreve"
                                    name="descrizione"
                                    type="textarea"
                                    onChange={(e) => { dispatch({ type: 'MODIFICA_DESCRIZIONEBREVE', payload: e.target.value }) }}
                                />
                            </Col>
                        </Col>
                    </Row>
                    <Row>
                        <Col className='mb-1' sm='12'>
                            <Label className='form-label' for='note'>
                                Note
                            </Label>
                            <Col sm={12}>
                                <Input
                                    value={state.note || ''}
                                    id="note"
                                    name="note"
                                    type="textarea"
                                    onInput={(e) => { dispatch({ type: 'MODIFICA_NOTE', payload: e.target.value }) }}
                                />

                            </Col>
                        </Col>
                    </Row>
                    <Button.Ripple type='Submit' color='primary'>Salva</Button.Ripple>
                </Form>
            </CardBody>
        </Card>
    )
}

export default DetailsGeneral